import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { BuildingLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const Building_Sanction_Building_Home = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {BuildingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass"> {t("Building Sanction")}</h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <div className="unit-area-assessment">
                      <p className="fontSizeClass">
                        <b>
                          {t(
                            "(a) The pre-conditions for an application for building sanction plan"
                          )}{" "}
                          :
                        </b>
                      </p>
                      <p className="fontSizeClass">
                        {t(
                          "Person/persons having right of erection on a plot of land, or who is the owner of a plot of land having deed of conveyance and mutation certificate and has no dues towards property and other Municipal tax may apply for a building sanction plan subject to details covered in para (c)"
                        )}
                        .
                      </p>
                      <br />
                      &nbsp;
                      <p className="fontSizeClass">&nbsp; </p> <br />
                      <p className="fontSizeClass">
                        <b>
                          {t(
                            "(b) Parameter of rate chart on various items of building sanction"
                          )}{" "}
                          :
                        </b>
                      </p>
                      <p className="fontSizeClass">
                        This varies from time to time.{" "}
                        {/* {t("This varies from time to time. Click here to view the schedule of fees for the current financial year")}. */}
                        <DownloadFileByFileStoreId
                          fileStoreId={"879a4e97-73a3-4943-a963-ed288d49d6c5"}
                          label={ "Click here to view the schedule of fees for the current financial year."}
                          classAdd={false} />
                      </p>
                      <br />
                      <p className="fontSizeClass">&nbsp; </p> <br />
                      <p className="fontSizeClass">
                        <b>
                          {t(
                            "(c) Check list for application for building sanction for normal building premises and for high rise building premises including provision of lift"
                          )}
                          .
                        </b>
                        {" "}
                        <DownloadFileByFileStoreId
                          fileStoreId={"7b69ac84-9cf8-4947-ae32-8afed2a505d3"}
                          label={"Click here to view the checklist"}
                          classAdd={false}
                        />
                      </p>{" "}
                      &nbsp; <br />
                      <p className="fontSizeClass">
                        <b>
                          {t(
                            "(d) Occasions when orders for demolition or stoppage of building are issued"
                          )}{" "}
                          :
                        </b>
                      </p>
                      <p className="fontSizeClass">
                        {t(
                          "Any construction work carried out without a valid sanction plan is liable to demolition. Initially, after detection of such illegal construction, a stop work notice is served. There after KMC authority deals it under section 400 (I) or 400 (8) of KMCAct 1980. U/s 400 (1) the case is disposed off by hearing where the structure may be demolished / part demolished / fully retained considering degree of violation of rule as well as structural safety. The cases where there is danger and / or violation of rule, KMC authority may directly demolish the structure without giving chance of hearing U/S 400(8)"
                        )}
                        .
                      </p>
                      <br />
                      <p className="fontSizeClass">&nbsp; </p> <br />
                      <p className="fontSizeClass d-flex">
                       <span className="mr-1">  {t( "(e) Requirement and format of completion certificate ")}  </span>                                 
                        <DownloadFileByFileStoreId
                          fileStoreId={"072de459-e947-4fb1-a50d-bd58aa4258e4"}
                          label={"Download"}
                          classAdd={false} />
                      </p>
                      <br /> <p className="fontSizeClass">&nbsp; </p> <br />
                      <p className="fontSizeClass">
                        <b>
                          (f){" "}
                          <a href={`${mainURL}/citizen/language-selection`}>
                            {" "}
                            {t(
                              " List of Registered License Building Surveyors/Empanelled Structural Engineer"
                            )}{" "}
                          </a>
                        </b>
                      </p>
                      <br /> <p className="fontSizeClass">&nbsp; </p> <br />
                      <p className="fontSizeClass">
                        <b>
                          {t(
                            "(g) Scope of appeal in Municipal Building Tribunal"
                          )}{" "}
                          :
                        </b>
                      </p>
                      <p className="fontSizeClass">
                        {t(
                          "Refer para (d). If a case of illegal construction is dealt u/s 400 (1) and a oeder of Special Officer (B) is passed. Being agreed by the order of SO (B), any appeal may be preferred U/s 415 of KMC Act 1980 to the Municipal Building Tribunal by the person responsible or complainant"
                        )}
                        .
                      </p>
                      <br /> <p className="fontSizeClass">&nbsp; </p> <br />
                      <p className="fontSizeClass">
                        <b>
                          {t(
                            "(h) Various regulations of Building uses as per provisions of the Act"
                          )}
                          .
                        </b>
                      </p>
                      <p className="fontSizeClass">
                        {t("As contained in the KMC Building Rules, 2009")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Building_Sanction_Building_Home;
